import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-green-800 text-white w-full max-w-full overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
          <div className="w-full">
            <div className="mb-4">
              <div className="bg-white p-3 rounded-lg inline-block">
                <img 
                  src="/assets/img/logo-cgciparis.png" 
                  alt="Logo Consulat Général de Côte d\'Ivoire à Paris" 
                  className="h-16" 
                />
              </div>
            </div>
            {/* Titre accessible pour respecter jsx-a11y/heading-has-content */}
            <h3 className="text-lg font-semibold mb-4">Consulat Général de Côte d&apos;Ivoire à Paris</h3>
          </div>
          <div className="w-full">
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2 w-full">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white">Accueil</Link>
              </li>
              <li>
                <Link to="/actes/1c34d0de-38f7-4bc6-91cc-88000ff61f42" className="text-gray-300 hover:text-white">Passeport</Link>
              </li>
              <li>
                <Link to="/search?category=d04405c5-84a8-4d6e-90dc-40ccdc1eb7ae" className="text-gray-300 hover:text-white">Transcriptions</Link>
              </li>
              <li>
                <Link to="/search?category=1bcac482-dc4d-4ae0-817e-2ce45699a62d" className="text-gray-300 hover:text-white">Visa</Link>
              </li>
              <li>
                <Link to="/actes/e94fa9da-ef78-4502-bcc4-4133d4744fb7" className="text-gray-300 hover:text-white">Carte Nationale d&apos;Identité</Link>
              </li>
              <li>
                <Link to="/search" className="text-gray-300 hover:text-white">Autres actes</Link>
              </li>
            </ul>
          </div>
          <div className="w-full">
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <address className="not-italic text-gray-300 space-y-2 w-full">
              <p>19 rue de la pépinière</p>
              <p>75008 Paris, France</p>
              <p>Téléphone: +33 1 81 72 66 04</p>
              <p>Email: consulat.france@diplomatie.gouv.ci</p>
            </address>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-300 text-center text-gray-300 w-full">
          <div className="flex justify-center space-x-4 mb-4">
            <Link to="/mentions-legales" className="text-gray-300 hover:text-white">Mentions légales</Link>
            <Link to="/politique-de-confidentialite" className="text-gray-300 hover:text-white">Politique de confidentialité</Link>
          </div>
          <p className="w-full">&copy; {new Date().getFullYear()} Consulat Général de Côte d&apos;Ivoire à Paris. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
